import { Brick, BrickContext, registerBrick, Query, QueryResult } from 'olympe';
import Component from '../../../models/Component';
import Evaluation from '../../../models/Evaluation';
import Inspection from '../../../models/Inspection';
import InspectionEntity from '../../../models/InspectionEntity';
import System from '../../../models/System';

export default class LoadSystemComponents extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} system
     * @param {function()} forwardEvent
     * @param {function(*)} setLoadedSystem
     */
    async update($, [system], [forwardEvent, setLoadedSystem]) {
        await this.loadSComponent($, system);
        setLoadedSystem(system);
        forwardEvent();
    }

    /**
     * @private
     * @param {!BrickContext} $
     * @param {!System} system
     * @return {!Promise<!Array<!QueryResult>>}
     */
    async loadSComponent($, system) {
        const systemTranslated = await Query.from(system).follow(System.translatedNameRel).andReturn().execute();

        const rootComponents = await Query.from(system).andReturn().follow(System.componentsRel).andReturn().follow(Component.translatedNameRel).andReturn().execute();

        const subComponents = await Query.from(system)
            .andReturn()
            .follow(System.allComponentsRel)
            .follow(Component.subComponentsRel)
            .andReturn()
            .follow(InspectionEntity.translatedNameRel)
            .andReturn()
            .execute();

        const inspections = await Query.from(system)
            .follow(System.allComponentsRel)
            .follow(Component.inspectionsRel)
            .andReturn()
            .follow(InspectionEntity.translatedNameRel)
            .andReturn()
            .execute();

        const evaluations = await Query.from(system)
            .follow(System.allComponentsRel)
            .follow(Component.inspectionsRel)
            .follow(Inspection.evaluationsListRel)
            .andReturn()
            .follow(Evaluation.translatedNameRel)
            .andReturn()
            .execute();

        return Promise.all([systemTranslated, rootComponents, subComponents, inspections, evaluations]).then((results) => {
            // Keep them in cache, avoid garbage collection until clear of this brick:
            const key = `loaded_system_${system.getTag()}`;
            $.set(key, results);
            $.onClear(() => $.remove(key));
        });
    }
}

registerBrick('018a92835dffc2ac45fa', LoadSystemComponents);
